<template>
    <div
        v-bind:id="pageHeaderId"
        v-bind:class="{ 'use-hover': applyHoverStyle }"
        class="d-flex flex-column align-items-center text-center h-100">
        <div
            v-bind:class="backgroundClass"
            class="text-white fw-bold rounded pagination-num d-flex justify-content-center align-items-center">
            {{ page.PageNumber }}
        </div>
        <div
            data-test-role="page-title"
            v-bind:class="{ 'fw-bold': isCurrentPage }"
            class="pagination-text w-100">
            {{ page.Title }}
        </div>
    </div>
</template>

<script>
    import { isModuleRegistered } from "SharedStores/util";
    import { PROJECT_FORM_NAMESPACE } from "./ProjectForm/projectFormStore";
    import { isPageComplete } from "./ProjectForm/ProjectElements/isComplete";

    export default {
        props: {
            page: { type: Object, required: true },
            currentPageNumber: { type: Number, required: false, default: 1 },
            applyHoverStyle: { type: Boolean, required: false, default: false }
        },
        computed: {
            pageHeaderId() {
                return `page-header${this.page.PageNumber}`;
            },
            isCurrentPage() {
                return this.currentPageNumber === this.page.PageNumber;
            },
            backgroundClass() {
                if (this.isCurrentPage) {
                    return "bg-primary-600";
                }
                if (this.isComplete) {
                    return "bg-success";
                }
                return "bg-gray-800";
            },
            isComplete() {
                const isProjectFormModuleRegistered = isModuleRegistered(PROJECT_FORM_NAMESPACE, this.$store.state);
                if (isProjectFormModuleRegistered) {
                    return isPageComplete(this.page, this.$store.getters);
                }
                return false;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .use-hover:hover {
        cursor: pointer;
        .pagination-text {
            $shadow_size: 0.15rem;
            text-shadow: $shadow_size $shadow_size $shadow_size var(--bs-gray-500);
        }
        .pagination-num {
            box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.8);
        }
    }
    .pagination-num {
        height: 2rem;
        width: 2rem;
    }
</style>
